export const SEND_DELIVERY_GUY_GPS_LOCATION = "SEND_DELIVERY_GUY_GPS_LOCATION";
export const GET_DELIVERY_GUY_GPS_LOCATION = "GET_DELIVERY_GUY_GPS_LOCATION";
